module.exports = __webpack_public_path__ + "static/media/chess-icon.95408f46.webp";